import React from "react";
import PropTypes from "prop-types";
import WidgetReloader from "./WidgetReloader";

const Widget = ({ children, onReload, header, isLoading = false }) => {
  return (
    <div className="widget">
      <h2 className="text-center">{header}</h2>
      {!isLoading && <WidgetReloader onClick={onReload} />}
      {children}
    </div>
  );
};

Widget.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onReload: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default Widget;



// WEBPACK FOOTER //
// ./src/dashboard/widgets/Widget.js